/* ==========================================================================
   Ormonde Jayne — Tasting Menus (collection page + Tasting Menu PDP)
   Loaded by sections/oj-tasting-collection.liquid and sections/oj-tasting-pdp.liquid.

   - Fragrance drawer (shared): fed by the JSON emitted per page into
     <script data-oj-tm-data>, opened by any [data-oj-tm-open="handle"].
   - Add to cart: POST /cart/add.js then the theme cart notification.
   - Collection: vial tray expand, "How to taste" step reveal.
   - PDP: gallery thumbs / mobile dots, accordions, style chips, sticky bar.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ojTastingInit) return;
  window.__ojTastingInit = true;

  var page = document.querySelector('[data-oj-tm-page], [data-oj-tm-social]');
  if (!page) return;

  function raf(fn) {
    var tick = null;
    return function () {
      if (tick) return;
      tick = window.requestAnimationFrame(function () { tick = null; fn(); });
    };
  }

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---- Fragrance data ---------------------------------------------------- */
  var DATA = {};
  $all('script[data-oj-tm-data]').forEach(function (el) {
    try {
      var parsed = JSON.parse(el.textContent);
      Object.keys(parsed).forEach(function (k) { DATA[k] = parsed[k]; });
    } catch (e) { /* malformed data block */ }
  });
  window.OJTastingData = DATA;

  /* ---- Drawer ------------------------------------------------------------ */
  var drawer = document.querySelector('[data-oj-tm-drawer]');
  var drawerPanel = drawer ? drawer.querySelector('.oj-tm-drawer__panel') : null;
  var lastFocus = null;

  function setText(sel, text) {
    if (!drawer) return;
    var el = drawer.querySelector(sel);
    if (el) el.textContent = text || '';
  }

  function openDrawer(handle, trigger) {
    var f = DATA[handle];
    if (!f || !drawer) return;
    lastFocus = trigger || document.activeElement;
    setText('[data-oj-tm-drawer-where]', f.where);
    setText('[data-oj-tm-drawer-name]', f.name);
    setText('[data-oj-tm-drawer-style]', f.style);
    setText('[data-oj-tm-drawer-profile]', f.profile);
    setText('[data-oj-tm-drawer-headline]', f.headline);
    setText('[data-oj-tm-drawer-head]', f.head);
    setText('[data-oj-tm-drawer-heart]', f.heart);
    setText('[data-oj-tm-drawer-soul]', f.soul);
    setText('[data-oj-tm-drawer-note]', f.note);
    setText('[data-oj-tm-drawer-price]', f.price);
    var noteWrap = drawer.querySelector('[data-oj-tm-drawer-note-wrap]');
    if (noteWrap) noteWrap.hidden = !f.note;
    var bottle = drawer.querySelector('[data-oj-tm-drawer-bottle]');
    if (bottle) { bottle.src = f.bottle || ''; bottle.alt = f.name || ''; bottle.hidden = !f.bottle; }
    var vial = drawer.querySelector('[data-oj-tm-drawer-vial]');
    var vialCol = drawer.querySelector('.oj-tm-drawer__vial-col');
    if (vial) { vial.src = f.vial || ''; vial.alt = f.vial ? (f.name + ', 2.5 ml vial') : ''; }
    if (vialCol) vialCol.hidden = !f.vial;
    var link = drawer.querySelector('[data-oj-tm-drawer-link]');
    if (link) link.href = f.url || '#';

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('oj-tm-drawer-open');
    if (drawerPanel) {
      drawerPanel.scrollTop = 0;
      setTimeout(function () { try { drawerPanel.focus({ preventScroll: true }); } catch (e) { drawerPanel.focus(); } }, 40);
    }
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('oj-tm-drawer-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-oj-tm-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-oj-tm-open'), opener);
      return;
    }
    if (e.target.closest('[data-oj-tm-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Enter' || e.key === ' ') {
      var t = e.target;
      if (t && t.matches && t.matches('[role="button"][data-oj-tm-open]')) {
        e.preventDefault();
        openDrawer(t.getAttribute('data-oj-tm-open'), t);
      }
    }
  });

  /* ---- Add to cart ------------------------------------------------------- */
  function setButtonLabel(btn, text) {
    var span = btn.querySelector('span');
    if (span && btn.classList.contains('oj-tm-btn')) span.textContent = text;
    else btn.textContent = text;
  }

  function openCartNotification() {
    try {
      if (window.cart_popup && typeof window.cart_popup.updateCartPopup === 'function' && window.jQuery) {
        window.cart_popup.updateCartPopup(function () {
          window.jQuery('.cart-popup-wrapper').addClass('open');
          window.jQuery('html').removeClass('cart-popup-wrapper-open').addClass('cart-popup-wrapper-open');
        });
      }
    } catch (e) { /* cart popup unavailable */ }
  }

  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-oj-tm-add'), 10);
    if (!id || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.getAttribute('data-label') || '';
    var added = btn.getAttribute('data-label-added') || label;
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || (r.data && r.data.status)) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart');
        setButtonLabel(btn, added);
        clearTimeout(btn._ojT);
        btn._ojT = setTimeout(function () { setButtonLabel(btn, label); }, 1800);
        openCartNotification();
        document.dispatchEvent(new CustomEvent('oj-tasting:added', { detail: { variantId: id } }));
      })
      .catch(function (err) {
        setButtonLabel(btn, (err && err.message) || 'Could not add to cart');
        clearTimeout(btn._ojT);
        btn._ojT = setTimeout(function () { setButtonLabel(btn, label); }, 2500);
      })
      .then(function () { btn.setAttribute('aria-busy', 'false'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oj-tm-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---- Collection: vial trays ------------------------------------------- */
  function setTray(card, open) {
    var peek = card.querySelector('[data-oj-tm-tray-peek]');
    var full = card.querySelector('[data-oj-tm-tray-full]');
    var toggle = card.querySelector('[data-oj-tm-tray-toggle]');
    if (peek) peek.hidden = open;
    if (full) full.hidden = !open;
    if (toggle) {
      toggle.textContent = open ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (!open && peek) {
      var top = peek.getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 120, behavior: 'smooth' });
    }
  }
  document.addEventListener('click', function (e) {
    var expand = e.target.closest('[data-oj-tm-tray-expand]');
    var toggle = e.target.closest('[data-oj-tm-tray-toggle]');
    if (!expand && !toggle) return;
    e.preventDefault();
    var card = (expand || toggle).closest('[data-oj-tm-menu]');
    if (!card) return;
    var isOpen = !!(card.querySelector('[data-oj-tm-tray-full]') && !card.querySelector('[data-oj-tm-tray-full]').hidden);
    setTray(card, expand ? true : !isOpen);
  });

  /* ---- Collection: How to taste reveal ---------------------------------- */
  var steps = $all('[data-oj-tm-step]');
  if (steps.length) {
    if ('IntersectionObserver' in window) {
      var stepIO = new IntersectionObserver(function (entries) {
        var fresh = entries.filter(function (en) { return en.isIntersecting && !en.target.classList.contains('is-on'); })
          .map(function (en) { return en.target; })
          .sort(function (a, b) { return steps.indexOf(a) - steps.indexOf(b); });
        fresh.forEach(function (el, k) {
          var inner = el.querySelector('.oj-tm-step__inner');
          if (inner) inner.style.transitionDelay = (k * 220) + 'ms';
          el.classList.add('is-on');
          stepIO.unobserve(el);
        });
      }, { threshold: 0.35 });
      steps.forEach(function (el) { stepIO.observe(el); });
    } else {
      steps.forEach(function (el) { el.classList.add('is-on'); });
    }
  }

  /* ---- PDP: gallery ------------------------------------------------------ */
  var gallery = document.querySelector('[data-oj-tm-gallery]');
  if (gallery) {
    var thumbs = $all('[data-oj-tm-thumb]', gallery);
    var slides = $all('[data-oj-tm-slide]', gallery);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-oj-tm-thumb');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.getAttribute('data-oj-tm-slide') === i); });
      });
    });
  }
  var mTrack = document.querySelector('[data-oj-tm-gallery-m-track]');
  if (mTrack) {
    var dots = $all('.oj-tm-gallery-m__dot', mTrack.parentNode);
    var tick = null;
    mTrack.addEventListener('scroll', function () {
      if (tick) return;
      tick = window.requestAnimationFrame(function () {
        tick = null;
        var w = mTrack.clientWidth || 1;
        var i = Math.round(mTrack.scrollLeft / w);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      });
    }, { passive: true });
  }

  /* ---- PDP: accordions --------------------------------------------------- */
  $all('[data-oj-tm-acc]').forEach(function (acc) {
    var buttons = $all('.oj-tm-acc__btn', acc);
    function setOpen(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var glyph = btn.querySelector('.oj-tm-acc__glyph');
      if (glyph) glyph.textContent = open ? '–' : '+';
      if (panel) panel.hidden = !open;
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (b) { setOpen(b, false); });
        if (!open) setOpen(btn, true);
      });
    });
  });

  /* ---- PDP: style chips -------------------------------------------------- */
  var chips = document.querySelector('[data-oj-tm-chips]');
  if (chips) {
    var chipButtons = $all('[data-oj-tm-chip]', chips);
    var courses = $all('[data-oj-tm-course]');
    function applyChip(value) {
      var needle = (value || '').toLowerCase();
      chipButtons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-oj-tm-chip') === value ? 'true' : 'false'); });
      courses.forEach(function (course) {
        var cards = $all('.oj-tm-card', course);
        var shown = 0;
        cards.forEach(function (card) {
          var styles = (card.getAttribute('data-styles') || '').toLowerCase().split('|');
          var ok = !needle || styles.some(function (st) { return st.indexOf(needle) !== -1; });
          card.classList.toggle('is-hidden', !ok);
          if (ok) shown += 1;
        });
        var count = course.querySelector('[data-oj-tm-course-count]');
        if (count) count.textContent = shown + ' ' + (shown === 1 ? count.getAttribute('data-singular') : count.getAttribute('data-plural'));
        var empty = course.querySelector('[data-oj-tm-course-empty]');
        if (empty) {
          empty.hidden = shown > 0;
          empty.textContent = (empty.getAttribute('data-template') || '').replace('[style]', (value || '').toLowerCase());
        }
      });
    }
    chipButtons.forEach(function (b) { b.addEventListener('click', function () { applyChip(b.getAttribute('data-oj-tm-chip') || ''); }); });
  }

  /* ---- PDP: sticky bar (mobile) ------------------------------------------ */
  var sticky = document.querySelector('[data-oj-tm-sticky]');
  var atcWrap = document.querySelector('[data-oj-tm-atc-wrap]');
  if (sticky && atcWrap && 'IntersectionObserver' in window) {
    var stickyIO = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var out = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', out);
      sticky.setAttribute('aria-hidden', out ? 'false' : 'true');
    }, { threshold: 0 });
    stickyIO.observe(atcWrap);
  }
  /* ---- Collection: mobile menu slider linked to page scroll ------------- */
  var menus = document.querySelector('[data-oj-tm-menus]');
  if (menus) {
    var menusGrid = menus.querySelector('[data-oj-tm-menus-grid]');
    var menusPin = menus.querySelector('.oj-tm-menus__pin');
    var dotsWrap = menus.querySelector('[data-oj-tm-menus-dots]');
    var menuCards = $all('[data-oj-tm-menu]', menusGrid);
    var mobileMQ = window.matchMedia('(max-width: 767px)');
    var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var linked = false, travel = 0, pinTop = 80;

    var dots = [];
    if (dotsWrap && menuCards.length > 1) {
      menuCards.forEach(function (card, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'oj-tm-menus__dot';
        d.setAttribute('aria-label', (dotsWrap.getAttribute('data-dot-label') || 'Show menu') + ' ' + (i + 1));
        d.addEventListener('click', function () { goToCard(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }
    function cardStep() { return menuCards.length > 1 ? (menuCards[1].offsetLeft - menuCards[0].offsetLeft) : menusGrid.clientWidth; }
    function updateDots() {
      if (!dots.length) return;
      var i = Math.round(menusGrid.scrollLeft / Math.max(1, cardStep()));
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function syncMenus() {
      if (!linked || travel <= 0) return;
      var rect = menus.getBoundingClientRect();
      var progress = (pinTop - rect.top) / travel;
      progress = Math.max(0, Math.min(1, progress));
      menusGrid.scrollLeft = progress * travel;
    }
    function measureMenus() {
      linked = mobileMQ.matches && !reduceMQ.matches;
      menus.classList.toggle('oj-tm-menus--linked', linked);
      if (!linked) { menus.style.height = ''; menus.style.removeProperty('--oj-tm-pin-top'); updateDots(); return; }
      var nav = document.querySelector('nav.main-header-nav');
      var headerH = nav ? Math.round(nav.getBoundingClientRect().height) : 80;
      travel = Math.max(0, menusGrid.scrollWidth - menusGrid.clientWidth);
      var pinH = menusPin.offsetHeight;
      pinTop = Math.min(headerH, window.innerHeight - pinH);
      menus.style.setProperty('--oj-tm-pin-top', pinTop + 'px');
      menus.style.height = (pinH + travel) + 'px';
      syncMenus();
      updateDots();
    }
    function goToCard(i) {
      var left = i * cardStep();
      if (linked) {
        var rect = menus.getBoundingClientRect();
        window.scrollTo({ top: window.scrollY + rect.top - pinTop + left, behavior: 'smooth' });
      } else {
        menusGrid.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    menusGrid.addEventListener('scroll', raf(updateDots), { passive: true });
    window.addEventListener('scroll', raf(syncMenus), { passive: true });
    window.addEventListener('resize', raf(measureMenus));
    window.addEventListener('load', measureMenus);
    if (mobileMQ.addEventListener) { mobileMQ.addEventListener('change', measureMenus); reduceMQ.addEventListener('change', measureMenus); }
    if ('ResizeObserver' in window) new ResizeObserver(raf(measureMenus)).observe(menusPin);
    measureMenus();
  }

  /* ---- Instagram story strip + viewer ----------------------------------- */
  var social = document.querySelector('[data-oj-tm-social]');
  if (social) {
    var stories = [];
    try { stories = JSON.parse(social.querySelector('script[data-oj-tm-stories]').textContent) || []; } catch (e) { stories = []; }
    var strip = social.querySelector('[data-oj-tm-strip]');
    var viewer = social.querySelector('[data-oj-tm-viewer]');
    var viewerMedia = viewer.querySelector('[data-oj-tm-viewer-media]');
    var viewerBars = $all('[data-oj-tm-viewer-bars] > span > span', viewer);
    var viewerCounter = viewer.querySelector('[data-oj-tm-viewer-counter]');
    var muteBtn = viewer.querySelector('[data-oj-tm-viewer-mute]');
    var imageMs = (parseFloat(social.getAttribute('data-image-seconds')) || 5) * 1000;
    var current = -1, muted = true, imgTimer = null, stripVisible = false, storyFocus = null;

    var tiles = $all('[data-oj-tm-story]', strip);
    var visibleTiles = [];
    function syncStrip() {
      tiles.forEach(function (tile) {
        var v = tile.querySelector('video');
        if (!v) return;
        var play = current < 0 && (stripVisible || visibleTiles.indexOf(tile) !== -1);
        if (play) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (!v.paused) v.pause();
      });
    }
    if ('IntersectionObserver' in window) {
      var tileIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var i = visibleTiles.indexOf(en.target);
          if (en.isIntersecting && i === -1) visibleTiles.push(en.target);
          if (!en.isIntersecting && i !== -1) visibleTiles.splice(i, 1);
        });
        syncStrip();
      }, { threshold: 0.35 });
      tiles.forEach(function (tile) { tileIO.observe(tile); });
      strip.addEventListener('scroll', raf(syncStrip), { passive: true });
    } else { stripVisible = true; syncStrip(); }

    function setBars(i, p) {
      viewerBars.forEach(function (b, k) {
        b.style.transition = (k === i && p > 0) ? 'width 0.25s linear' : 'none';
        b.style.width = (k < i ? 100 : k === i ? p * 100 : 0) + '%';
      });
    }
    function clearMedia() { clearInterval(imgTimer); imgTimer = null; viewerMedia.innerHTML = ''; }
    function showStory(i) {
      var st = stories[i];
      if (!st) return;
      current = i;
      clearMedia();
      setBars(i, 0);
      if (viewerCounter) viewerCounter.textContent = (i + 1) + ' / ' + stories.length;
      if (muteBtn) muteBtn.hidden = st.type !== 'video';
      if (st.type === 'video') {
        var v = document.createElement('video');
        v.src = st.src;
        if (st.poster) v.poster = st.poster;
        v.autoplay = true; v.muted = muted; v.playsInline = true; v.preload = 'auto';
        v.setAttribute('playsinline', '');
        v.addEventListener('timeupdate', function () { if (v.duration) setBars(i, v.currentTime / v.duration); });
        v.addEventListener('ended', function () { stepStory(1); });
        viewerMedia.appendChild(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else {
        var img = document.createElement('img');
        img.src = st.src; img.alt = '';
        viewerMedia.appendChild(img);
        var t0 = performance.now();
        imgTimer = setInterval(function () {
          var p = (performance.now() - t0) / imageMs;
          if (p >= 1) stepStory(1); else setBars(i, p);
        }, 50);
      }
      syncStrip();
    }
    function openViewer(i, trigger) {
      storyFocus = trigger || document.activeElement;
      viewer.classList.add('is-open');
      viewer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('oj-tm-viewer-open');
      showStory(i);
      setTimeout(function () { var c = viewer.querySelector('[data-oj-tm-viewer-close].oj-tm-viewer__btn'); if (c) { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } } }, 40);
    }
    function closeViewer() {
      if (!viewer.classList.contains('is-open')) return;
      clearMedia();
      current = -1;
      viewer.classList.remove('is-open');
      viewer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('oj-tm-viewer-open');
      syncStrip();
      if (storyFocus && typeof storyFocus.focus === 'function') { try { storyFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
      storyFocus = null;
    }
    function stepStory(d) {
      var n = current + d;
      if (n < 0) { showStory(0); return; }
      if (n >= stories.length) { closeViewer(); return; }
      showStory(n);
    }
    social.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-oj-tm-story]');
      if (tile) { e.preventDefault(); openViewer(parseInt(tile.getAttribute('data-oj-tm-story'), 10), tile); return; }
      if (e.target.closest('[data-oj-tm-viewer-mute]')) {
        muted = !muted;
        var vid = viewerMedia.querySelector('video');
        if (vid) vid.muted = muted;
        muteBtn.textContent = muted ? muteBtn.getAttribute('data-off') : muteBtn.getAttribute('data-on');
        return;
      }
      if (e.target.closest('[data-oj-tm-viewer-close]')) { closeViewer(); return; }
      if (e.target.closest('[data-oj-tm-viewer-prev]')) { stepStory(-1); return; }
      if (e.target.closest('[data-oj-tm-viewer-next]')) { stepStory(1); }
    });
    document.addEventListener('keydown', function (e) {
      if (current < 0) return;
      if (e.key === 'Escape') closeViewer();
      else if (e.key === 'ArrowRight') stepStory(1);
      else if (e.key === 'ArrowLeft') stepStory(-1);
    });
  }
})();
